module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"item":"No item | {n} item |  {n} items","cancel":"Cancel","confirm":"Confirm"}}')
  delete Component.options._Ctor
}
